import { render } from "./ProductMgmt.vue?vue&type=template&id=15fc18ba&scoped=true"
import script from "./ProductMgmt.vue?vue&type=script&lang=js"
export * from "./ProductMgmt.vue?vue&type=script&lang=js"

import "./ProductMgmt.vue?vue&type=style&index=0&id=15fc18ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15fc18ba"]])

export default __exports__